import moment from 'moment-timezone';
import { getClosestEqualOrBiggerDivisibleNumber } from './number-utils';
import { Timestamp } from '../services/Timestamp';
import { approximationIntervalInMilliseconds } from '../components/Map/constants/constants';

export const approximateTimestamp = (timestamp: Timestamp): Timestamp => {
  const milliseconds = getClosestEqualOrBiggerDivisibleNumber(
    timestamp.toMilliseconds(),
    approximationIntervalInMilliseconds
  );
  return Timestamp.fromMilliseconds(milliseconds);
};

export const isNavigableTimestamp = (timestamp: Timestamp): boolean => {
  return timestamp && timestamp.toSeconds() < Timestamp.now().toSeconds();
};

export const isLive = (timestamp: Timestamp): boolean => {
  const oldestLiveTimestamp = Timestamp.now().subtract(Timestamp.fromMinutes(60));
  return timestamp.valueInMilliseconds >= oldestLiveTimestamp.valueInMilliseconds;
};

export const isToday = (timestamp: Timestamp, timezone: string): boolean => {
  const today = moment(Timestamp.now().valueInMilliseconds).tz(timezone).dayOfYear();
  const timestampDay = moment(timestamp.valueInMilliseconds).tz(timezone).dayOfYear();
  return today === timestampDay;
};

export const isYesterday = (timestamp: Timestamp, timezone: string): boolean => {
  const yesterday = moment(Timestamp.now().valueInMilliseconds)
    .tz(timezone)
    .subtract(Timestamp.fromHours(24).toMilliseconds(), 'milliseconds')
    .dayOfYear();
  const timestampDay = moment(timestamp.valueInMilliseconds).tz(timezone).dayOfYear();
  return yesterday === timestampDay;
};
